import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import path from "path";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
export default {
  name: "SidebarItem",
  components: {
    Item: Item,
    AppLink: AppLink
  },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {};
  },
  computed: {
    currPath: function currPath() {
      return this.$route.path;
    },
    defaultTheme: function defaultTheme() {
      return this.$store.state.settings.theme;
    },
    leftNavBg: function leftNavBg() {
      return this.$store.state.settings.leftNavBg;
    },
    leftNavTextColor: function leftNavTextColor() {
      return this.$store.state.settings.leftNavTextColor;
    },
    leftNavSetBg: function leftNavSetBg() {
      return this.$store.state.settings.leftNavSetBg;
    }
  },
  methods: {
    itemMouseleve: function itemMouseleve(currItem) {
      this.$refs[currItem].$el.style.background = "";
    },
    itemMouse: function itemMouse(currItem) {
      this.$refs[currItem].$el.style.background = "rgba(".concat(this.colorConversionRgb(this.leftNavSetBg), ", .4)");
    },
    hasOneShowingChild: function hasOneShowingChild() {
      var _this = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          _this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: "",
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    resolvePath: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    }
  }
};